export default __webpack_public_path__ + "3a3f0d9265adef5ccedddb5352075331.png";